import type {
  CreateAnnouncementInput,
  CreateAnnouncementResponse,
  ListAnnouncementsResponse,
  ListNotificationsResponse,
  PushSubscriptionInput,
  VapidPublicKeyResponse,
} from "@mvk/shared";
import { apiRequest } from "./client";

export const notificationsApi = {
  list(unreadOnly = false) {
    const qs = unreadOnly ? "?unread=1" : "";
    return apiRequest<ListNotificationsResponse>(`/me/notifications${qs}`, {
      audience: "visitor",
    });
  },

  markRead(id: number) {
    return apiRequest<{ ok: boolean }>(`/me/notifications/${id}/read`, {
      method: "POST",
      audience: "visitor",
    });
  },

  markAllRead() {
    return apiRequest<{ ok: boolean; count: number }>("/me/notifications/read-all", {
      method: "POST",
      audience: "visitor",
    });
  },

  getVapidPublicKey() {
    return apiRequest<VapidPublicKeyResponse>("/me/push/vapid-public-key", {
      audience: "visitor",
    });
  },

  registerPush(body: PushSubscriptionInput) {
    return apiRequest<{ ok: boolean; channel: string }>("/me/push-subscriptions", {
      method: "POST",
      body,
      audience: "visitor",
    });
  },
};

export const announcementsApi = {
  create(eventId: string, body: CreateAnnouncementInput) {
    return apiRequest<CreateAnnouncementResponse>(`/events/${eventId}/announcements`, {
      method: "POST",
      body,
      audience: "admin",
    });
  },

  list(eventId: string) {
    return apiRequest<ListAnnouncementsResponse>(`/events/${eventId}/announcements`, {
      audience: "admin",
    });
  },
};
